import { render, staticRenderFns } from "./lio.vue?vue&type=template&id=6f45d85c&scoped=true&"
import script from "./lio.vue?vue&type=script&lang=js&"
export * from "./lio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f45d85c",
  null
  
)

export default component.exports